import "./CustomDatePicker.scss";
import React, { useState, Fragment, useEffect } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface PropData {
  onChange?: any;
  selected?: any;
  type?: string;
  minData?: any;
  maxData?: any;
  placeholderText?: any;
  isDisabled?: boolean;
}

const CustomDatePicker = (props: PropData) => {
  const [startDate, setStartDate] = useState<any>();
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    if (props.selected == "reset") {
      setStartDate(null);
    } else if (props.selected) {
      if (props.selected && props.selected != '0000-00-00' && props.selected != '0000-00-00 00:00:00') {
        setStartDate(new Date(props.selected) as any);
      }



    } else {
      setStartDate("")
    }
  }, [props.selected]);


  return (
    <>
      <Fragment>
        <div className="" key={new Date().getTime()}>
          {!props.type &&
            <DatePicker
              // onFocus={() => setShowDropdown(!showDropdown)}
              // open={showDropdown}
              className="form-control date-picker"
              selected={startDate}
              peekNextMonth
              dateFormat="dd-MMM-yyyy"
              dropdownMode="select"
              showMonthDropdown
              showYearDropdown
              disabled={props.isDisabled}
              minDate={props.minData ? props.minData : ""}
              maxDate={props.maxData ? props.maxData : ""}
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"));
                }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }
          {props.type == 'DATETIME' &&
            <DatePicker
              className="form-control"
              selected={startDate}
              disabled={props.isDisabled}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={30}
              timeCaption="Time"
              dateFormat="MM/dd/yy hh:mm aa"
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(date);
                }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }
          {props.type == 'MONTH' &&
            <DatePicker
              className="form-control"
              selected={startDate}
              dateFormat="MM"
              showMonthYearPicker
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(date);
                }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }

          {props.type === 'MONTH_YEAR' && (
            <DatePicker
              className="form-control"
              selected={startDate}
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(moment(date).format("YYYY-MM"));
                }
              }}
              showMonthYearPicker
              dateFormat="MMMM - yyyy"
              placeholderText={props.placeholderText || ""}
              disabled={props.isDisabled}
              renderCustomHeader={({ date, decreaseYear, increaseYear }) => {
                const year = moment(date).format("YYYY");
                return (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '0px' }}>
                    <button
                      type="button"
                      onClick={(e) => { e.preventDefault(); decreaseYear(); }}
                      aria-label="Previous Year"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '20px',
                        marginRight: '15px'
                      }}
                    >
                      &lt;
                    </button>
                    <span style={{ fontWeight: 'bold', fontSize: '1.2em', margin: '0 10px' }}>{year}</span>
                    <button
                      type="button"
                      onClick={(e) => { e.preventDefault(); increaseYear(); }}
                      aria-label="Next Year"
                      style={{
                        fontWeight: 'bold',
                        fontSize: '20px',
                        marginLeft: '15px'
                      }}
                    >
                      &gt;
                    </button>
                  </div>
                );
              }}
            />
          )}


          {
            props.type == 'DATE_MONTH' &&
            <DatePicker
              className="form-control form-style date-picker"
              selected={startDate}
              disabled={props.isDisabled}
              showMonthDropdown
              dateFormat="dd-MMM"
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(date);
                }
              }}
            />
          }
          {props.type == 'DATETIME' &&
            <DatePicker
              // className="form-control"
              selected={startDate}
              disabled={props.isDisabled}
              showTimeSelect
              timeFormat="hh:mm aa"
              timeIntervals={30}
              timeCaption="Time"
              dateFormat="hh:mm aa"
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(date);
                }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }
          {props.type == 'TIME' &&
            <DatePicker
              className="form-control"
              selected={startDate}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="LLL"
              onChange={(date: any) => {
                setStartDate(date);
                // if (props.onChange) {
                //   props.onChange(moment(date).format("HH:mm:ss"));
                // }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }
          {props.type == 'YEAR' &&
            <DatePicker
              className="form-control"
              selected={startDate}
              showYearPicker
              dateFormat="yyyy"
              yearItemNumber={9}
              onChange={(date: any) => {
                setStartDate(date);
                if (props.onChange) {
                  props.onChange(moment(date).format("YYYY"));
                }
              }}
              placeholderText={props.placeholderText ? props.placeholderText : ""}
            />
          }
        </div>
      </Fragment>
    </>
  );
};

CustomDatePicker.defaultProps = {
  placeholder: "Select",
  selected: "",
  isSearchable: false,
  key: new Date().getTime(),
};

export default CustomDatePicker;
